<template>
  <div>
    <FormularioEditBase
      :formulario="currentItem"
      :close="closeEdit"
      :context="context"
    />
    <RespostaBase
      :formulario="formulario"
      :perguntas="perguntas"
      :close="closeEdit"
    />

    <CTabs variant="tabs" class="nav-tabs-boxed">
      <CTab :title="tabTitulo">
        <!-- Formulários -->
        <div class="table-responsive">
          <!-- Botão de criar -->
          <div
            class="form-group pull-right"
            style="display: flex; justify-content: space-between"
          >
            <button @click="openCreate" class="button button-success">
              <fa-icon icon="plus" /> Criar
            </button>
          </div>
          <div v-if="loading" class="text-center p-5">
            <Loading :isActive="loading" />
          </div>

          <div
            v-else-if="Array.isArray(items) && items.length === 0"
            class="text-center p-5"
          >
            <p class="empty-text">
              Nenhum formulário de {{ context }} encontrado.
            </p>
          </div>

          <datatable
            v-else
            :columns="table.columns"
            :data="items"
            class="table table-hover"
          >
            <template slot-scope="{ row }">
              <tr>
                <td align="center">{{ row.id }}</td>
                <td>{{ row.titulo }}</td>
                <td align="center">{{ row.tipo }}</td>
                <td v-if="context === 'LGPD'" align="center">
                  /formulario/{{ row.slug }}
                </td>
                <td class="actions">
                  <button @click="openEdit(row)" class="button button-primary">
                    <fa-icon icon="pencil-alt" />
                  </button>
                  <button
                    @click="deleteConfirm(row)"
                    class="button button-error"
                  >
                    <fa-icon icon="trash-alt" />
                  </button>
                </td>
              </tr>
            </template>
          </datatable>
        </div>
      </CTab>

      <CTab title="Relatórios">
        <SearchBarBase
          :tiposPermitidos="tiposPermitidos"
          :sistema="sistema"
          :showTipoFormulario="showTipoFormulario"
          :showFormularioBusca="showFormularioBusca"
          @atualizar-lista="atualizarRespostas"
          @filtros-aplicados="guardarFiltros"
        />
        <div class="table-responsive">
          <div
            class="text-center form-group p-4"
            v-if="
              !Array.isArray(respostas.itens) || respostas.itens.length === 0
            "
          >
            <label>Não há respostas</label>
          </div>
          <datatable
            v-else
            :columns="table.columnsR"
            :data="respostas.itens"
            class="table table-hover"
          >
            <template slot-scope="{ row }">
              <tr>
                <td>{{ row.formularioTitulo }}</td>
                <td v-if="showFormularioBusca" align="center">
                  {{ row.clienteFantasia }}
                </td>
                <td v-if="showFormularioBusca" align="center">
                  {{ row.colaboradorNome }}
                </td>
                <td align="center">{{ formatDate(row.data) }}</td>
                <td class="actions">
                  <button
                    class="button button-success"
                    @click="openResposta(row)"
                  >
                    <CIcon name="cil-magnifying-glass" /> Visualizar
                  </button>
                </td>
              </tr>
            </template>
          </datatable>
          <pagination
            :data="respostas.paginator"
            :limit="2"
            @pagination-change-page="changePage"
          />
        </div>
      </CTab>
    </CTabs>
  </div>
</template>

<script>
import { get, del } from "@/helpers/apiRequest";
import RespostaBase from "./RespostaBase.vue";
import SearchBarBase from "./SearchBarBase.vue";
import { formatDate } from "@/helpers/utils";
import FormularioEditBase from "./FormularioEditBase.vue";

const initialState = {
  titulo: "",
  slug: "",
  tipo: "",
  descricao: "",
  perguntas: [],
  dataInicio: "",
  dataFim: "",
  acessab2b: 0,
  acessafv: 0,
  respostaUnica: 0,
  obrigatorio: 0,
  local: "",
  imagem: "",
  conteudo: "",
  restricoes: [],
};

export default {
  name: "FormularioBase",
  components: { FormularioEditBase, RespostaBase, SearchBarBase },
  props: {
    tiposPermitidos: { type: Array, required: true },
    sistema: { type: String, required: true },
    moduloKey: { type: String, required: true },
    tabTitulo: { type: String, default: "Formulários" },
    context: { type: String, required: true },
  },
  data() {
    return {
      currentItem: initialState,
      filtrosAtuais: {},
      loading: false,
      currentPage: 1,
      items: [],
      respostas: { itens: [], paginator: {} },
      perguntas: [],
      formulario: {},
      table: {
        columns: [],
        columnsR: [],
        paginator: {},
      },
      descPlural: "",
      descSingular: "",
    };
  },
  computed: {
    showTipoFormulario() {
      // Em LGPD queremos mostrar o tipo de formulário
      return this.context === "LGPD";
    },
    showFormularioBusca() {
      // Em Pesquisa queremos buscar formulário específico de orçamentos
      return this.context === "PESQUISA";
    },
  },
  methods: {
    formatDate,
    configurarColunasRelatorio() {
      if (this.context === "PESQUISA") {
        this.table.columnsR = [
          { label: "Formulário", field: "formularioTitulo" },
          { label: "Cliente", field: "clienteFantasia" },
          { label: "Colaborador", field: "colaboradorNome" },
          { label: "Data", field: "data" },
          { label: "", field: "" },
        ];
      }

      if (this.context === "LGPD") {
        this.table.columnsR = [
          { label: "Formulário", field: "formularioTitulo" },
          { label: "Data", field: "data" },
          { label: "", field: "" },
        ];
      }
    },
    configurarColunasFormulario() {
      const baseColumns = [
        { label: "ID", field: "id" },
        { label: "Título", field: "titulo" },
        { label: "Tipo", field: "tipo" },
      ];

      if (this.context === "LGPD") {
        baseColumns.push({ label: "Slug", field: "slug" });
      }

      baseColumns.push({ label: "", field: "" });

      this.table.columns = baseColumns;
    },

    loadDescricaoModulo() {
      const { modulos } = JSON.parse(localStorage.getItem("app"));
      const modulo = modulos.find((m) => m.nome === this.moduloKey);
      this.descPlural = modulo?.descPlural ?? "";
      this.descSingular = modulo?.descSingular ?? "";
    },
    loadFormularios() {
      this.loading = true;
      const query = this.tiposPermitidos
        .map((tipo) => `tipo[]=${tipo}`)
        .join("&");
      get(`/admin/formularios?${query}&sistema=${this.sistema}`)
        .then((json) => {
          this.items = json;
          this.table.paginator = json.paginator;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    loadRespostas() {
      this.loading = true;

      let tiposQuery = "";
      if (this.context === "LGPD") {
        tiposQuery = ["ACESSO_DADOS_PESSOAIS", "INCIDENTE_DADOS_PESSOAIS"]
          .map((tipo) => `tipo[]=${tipo}`)
          .join("&");
      } else if (this.context === "PESQUISA") {
        tiposQuery = "tipo[]=ORCAMENTO";
      }

      const url = `/admin/formularios/pergunta/respostas?${tiposQuery}&sistema=${this.sistema}`;

      get(url)
        .then((json) => {
          this.respostas = {
            itens: json.itens,
            paginator: json.paginator,
          };
          this.currentPage = json.paginator.current_page;
        })
        .catch(() => {
          this.$swal({
            title: "Erro!",
            text: "Erro ao carregar respostas.",
            icon: "error",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    guardarFiltros(filtros) {
      this.filtrosAtuais = filtros;
    },
    atualizarRespostas(dados) {
      this.respostas = { itens: dados.itens, paginator: dados.paginator };
      this.currentPage = dados.paginator.current_page;
    },
    changePage(page) {
      const params = new URLSearchParams({
        ...this.filtrosAtuais,
        page,
      }).toString();
      get(`/admin/formularios/pergunta/respostas?${params}`)
        .then(this.atualizarRespostas)
        .catch(console.error);
    },
    openEdit(item) {
      get(`/admin/formularios/${item.id}`).then((formulario) => {
        this.currentItem = formulario[0];
        this.$modal.show("formularioEdit");
      });
    },
    openCreate() {
      this.$modal.show("formularioEdit");
    },
    openResposta(resposta) {
      this.formulario = resposta;
      this.perguntas = resposta.perguntas;
      this.$modal.show("respostaModal");
    },
    refreshFormularios() {
      this.loadFormularios();
    },
    closeEdit() {
      this.$modal.hide("formularioEdit");
      this.$modal.hide("respostaModal");
      this.perguntas = [];
      this.currentItem = initialState;
      this.refreshFormularios();
    },
    deleteConfirm(item) {
      this.$swal({
        title: "Confirma Remover?",
        text: "Essa ação não poderá ser desfeita e removerá também as respostas.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Excluir",
        cancelButtonText: "Cancelar",
      }).then((res) => {
        if (res.value) {
          this.loading = true;
          del(`/admin/formularios/${item.id}`)
            .then(this.refreshFormularios)
            .catch(() => {
              this.$swal({ title: "Erro ao remover", icon: "error" });
            })
            .finally(() => (this.loading = false));
        }
      });
    },
  },
  mounted() {
    this.loadDescricaoModulo();
    this.configurarColunasRelatorio();
    this.configurarColunasFormulario();
    this.loadFormularios();
    this.loadRespostas();
  },
};
</script>
